import api from './api';

export const teamService = {
    listByWorkspace: (workspaceId: string) => api.get(`/workspaces/${workspaceId}/teams`),
};
